import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "transaction-chain-next",
  "use": "transaction-chain-next-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"transaction-chain-next\">\r\n<path d=\"M8.99988 7.50002L6.49988 7.5L4.29395 7.50002M8.99988 7.50002L7.73517 6M8.99988 7.50002L7.73517 9\" stroke=\"#C4C4C4\" />\r\n<circle cx=\"3.5\" cy=\"7.5\" r=\"2.5\" fill=\"#989A9B\" />\r\n<circle cx=\"12.5\" cy=\"7.5\" r=\"2\" stroke=\"#C4C4C4\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol